import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    // Master Home Page
    {
        path: '/master/',
        name: 'Master Home Page',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1.read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master')
    },

    // Master Fleet
    {
        path: '/master/fleet/',
        name: 'Master Fleet',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-v1'].read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/fleet')
    },
    {
        path: '/master/fleet/create/',
        name: 'Master Fleet Create',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Create', _)
                if (store.state.access.data.md1['md1-v1'].create) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/fleet/form')
    },
    {
        path: '/master/fleet/update/:id',
        name: 'Master Fleet Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Update', _)
                if (store.state.access.data.md1['md1-v1'].update) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/fleet/form')
    },
    {
        path: '/master/fleet/update/history/:id',
        name: 'Master Fleet Update History',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-v1'].update) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import(/* webpackChunkName: "master" */ '@/router/views/master/fleet/updatehistory')
    },

    // Master Driver
    {
        path: '/master/driver/',
        name: 'Master Driver',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/driver')
    },
    {
        path: '/master/driver/create/',
        name: 'Master Driver Create',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/driver/form')
    },
    {
        path: '/master/driver/update/:id',
        name: 'Master Driver Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/driver/form')
    },

    // Master Tracking
    {
        path: '/master/tracking/',
        name: 'Master Tracking',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1["md1-t1"].read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/tracking')
    },

    // Master Service
    {
        path: '/master/service/',
        name: 'Master Service',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/service')
    },

    {
        path: '/master/service/sparepartsadd',
        name: 'Service Spare Part Add',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/service/sparepartsadd')
    },


    {
        path: '/master/service/sparepartsupdate',
        name: 'Service Spare Part Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/service/sparepartsupdate')
    },

    // Master Address
    {
        path: '/master/address/',
        name: 'Master Address',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-a1'].read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/address')
    },
    {
        path: '/master/address/create/',
        name: 'Master Address Create',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1["md1-a1"].create) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/address/form')
    },
    {
        path: '/master/address/update/:id',
        name: 'Master Address Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-a1'].update) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/address/form')
    },

    {
        path: '/master/address/import/',
        name: 'Master Address Import',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-a1'].create) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/address/import')
    },

    {
        path: '/master/address/importresult/',
        name: 'Master Address Import Result',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-a1'].create) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/address/importresult')
    },

    // Master Customer
    {
        path: '/master/customer/',
        name: 'Master Customer',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/customer')
    },

    // Master Create Customer
    {
        path: '/master/customer/create/',
        name: 'Master Customer Create',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/customer/form')
    },

    // Detail Master Customer Detail
    {
        path: '/master/customer/customerdetail/address/',
        name: 'Master Customer Address',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/customer/address')
    },

    // Detail Master Customer Address
    {
        path: '/master/customer/customerdetail/address/:id',
        name: 'Master Customer Address Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/customer/address')
    },
    {
        path: '/master/customer/customerdetail/address/:id',
        name: 'Master Customer Detail Address',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/customer/form')
    },

    // Master Employee
    {
        path: '/master/employee/',
        name: 'Master Employee',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-e1'].read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/employee')
    },

    // Master Create Employee
    {
        path: '/master/employee/create/',
        name: 'Master Employee Create',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1['md1-e1'].create) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/employee/form')
    },

    // Detail Master Employee Detail
    {
        path: '/master/employee/employeedetail/:id',
        name: 'Master Employee Detail',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1["md1-e1"].update) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/employee/form')
    },

    // Detail Master Employee Detail Riwayat Perjalanan
    {
        path: '/master/employee/employeehistorydriver/:id',
        name: 'Riwayat Perjalanan Pengemudi',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1["md1-e1"].update) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/employee/employeehistorydriver')
    },

    {
        path: '/master/employee/import/',
        name: 'Master Employee Import',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1["md1-e1"].create) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/employee/import')
    },

    {
        path: '/master/employee/importresult/',
        name: 'Master Employee Import Result',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1["md1-e1"].read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/employee/importresult')
    },

    // Master User
    {
        path: '/master/user/',
        name: 'Master User',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.md1["md1-u1"].read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/master/user')
    },
]